export default __webpack_public_path__ + "static/Content-3-644ec7f3e82dd8e74655173a7115bea2.mp4";